import React, {useState} from 'react';
import '../styles/Services.css';

const conditions = [
  "Back Pain", "Spondylitis", "Scoliosis", "Piriformis Syndrome", "Spondyloarthropathies", "Stenosis", "Sacroiliac Joint Dysfunction", "Headaches With Neck Pain",
  "Lower Back Pain", "Spondylosis", "Spinal Arthritis", "Kyphosis", "Pregnancy Back Pain", "Facet Joint Arthropathy", "Spinal Canal Stenosis", "Lumbar Spinal Stenosis",
  "Neck Pain", "Sciatica", "Osteoporosis", "Disc Sequestration", "Upper Back Pain", "Back Pain In Children", "Cervical Spinal Canal Stenosis", "Coccydynia",
  "Slipped Disc", "Disc Bulge", "Pelvic Girdle Pain", "Fibromyalgia", "Spondylolisthesis", "Ankylosing Spondylitis", "Degenerative Disc Disease", "Lower Back Muscle Strain"
];

const ConditionsWeTreat = () => {
  const [expanded, setExpanded] = useState(true);

  const toggleView = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="conditions-container">
      <h2>Conditions We Treat</h2>
      <div className={`conditions-grid ${expanded ? 'expanded' : ''}`}>
        {conditions.map((condition, index) => (
          <div className="condition-item" key={index}>
            <span>{condition}</span>
            <span className="arrow">›</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConditionsWeTreat;
